// removed by extract-text-webpack-plugin
module.exports = {"BuildControl":"_1jYc3QBtl-VmgIWdCI3dgO","Label":"_33Z-plxrqIneM7Mz2ytOp0","Less":"_377MJOSYo2UYjMj1U14k03","More":"_28-hQFZzubxjJbKbVayD5m"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Burger/BuildControls/BuildControl/BuildControl.css
// module id = 126
// module chunks = 0